import { Component, ViewChildren } from '@angular/core';

import { TextEditorSettings } from '../../../models/text-editor-settings.model';
import { SurveyEditorService } from '../../../services/survey-editor.service';
import { TextEditorComponent } from '../../text-editor/text-editor.component';

@Component({
  selector: 'empathy-info-form',
  templateUrl: 'info-form.component.html',
  styleUrls: ['./info-form.component.scss']
})
export class InfoFormComponent {
  @ViewChildren(TextEditorComponent) ckEditor: TextEditorComponent[];

  infoSettings = new TextEditorSettings('textarea', true);

  constructor(public surveyEditorService: SurveyEditorService) {}
}
